import { render, staticRenderFns } from "./AdminCombo.vue?vue&type=template&id=c7f0bc44&"
import script from "./AdminCombo.vue?vue&type=script&lang=js&"
export * from "./AdminCombo.vue?vue&type=script&lang=js&"
import style0 from "./AdminCombo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports